import React, { useState } from 'react';
import '../../App.css';

const SettingsPage = () => {
  return (<div>UNDER CONSTRUCTION</div>)
  // State for toggle switches
  const [gameStartAlerts, setGameStartAlerts] = useState(true);
  const [bettingLineMoves, setBettingLineMoves] = useState(true);
  const [friendReviews, setFriendReviews] = useState(false);
  const [foamFingerUpvotes, setFoamFingerUpvotes] = useState(false);
  const [publicReviews, setPublicReviews] = useState(true);

  // State for selected teams
  const [selectedTeams, setSelectedTeams] = useState([
    'OKC Thunder',
    'LA Rams',
    'Chicago Bulls'
  ]);

  const teams = [
    { name: 'OKC Thunder', color: '#007ac1' },
    { name: 'LA Rams', color: '#003594' },
    { name: 'NY Mets', color: '#002d72' },
    { name: 'NY Rangers', color: '#002868' },
    { name: 'Boston Celtics', color: '#006241' },
    { name: 'SF Giants', color: '#fd5a1e' },
    { name: 'New England Patriots', color: '#003087' },
    { name: 'Minnesota Vikings', color: '#004687' },
    { name: 'Chicago Bulls', color: '#cf0a2c' }
  ];

  const handleTeamToggle = (teamName) => {
    setSelectedTeams(prev =>
      prev.includes(teamName)
        ? prev.filter(name => name !== teamName)
        : [...prev, teamName]
    );
  };

  return (
    <div id="page-settings" className="page-active">
      <div className="page-header">
        <div className="page-title">Settings</div>
      </div>

      <div className="settings-section">
        <div className="settings-section-title">Verification</div>
        <div className="verify-card">
          <div className="verify-icon">
            <i className="ti ti-shield-check" aria-hidden="true"></i>
          </div>
          <div className="verify-info">
            <div className="title">Get Verified <span style={{ color: 'var(--fd-blue)' }}>✓</span></div>
            <div className="desc">Photo ID verification via FaceTec biometric scan. Takes ~60 seconds.</div>
          </div>
          <button className="verify-btn">Verify Me</button>
        </div>
      </div>

      <div className="settings-section">
        <div className="settings-section-title">Favorite Teams</div>
        <div style={{ fontSize: '12px', color: 'var(--fd-muted)', marginBottom: '10px' }}>
          Selected teams are prioritized in your feed
        </div>
        <div className="team-chips">
          {teams.map(team => (
            <div
              key={team.name}
              className={`team-chip ${selectedTeams.includes(team.name) ? 'selected' : ''}`}
              onClick={() => handleTeamToggle(team.name)}
            >
              <div className="team-dot" style={{ background: team.color }}></div>
              {team.name}
            </div>
          ))}
          <div className="team-chip">+ More Teams</div>
        </div>
      </div>

      <div className="settings-section">
        <div className="settings-section-title">Notifications</div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Game Start Alerts</div>
            <div className="desc">Notify me when my favorite teams tip off</div>
          </div>
          <div
            className={`toggle ${gameStartAlerts ? '' : 'off'}`}
            onClick={() => setGameStartAlerts(!gameStartAlerts)}
          ></div>
        </div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Betting Line Moves</div>
            <div className="desc">Alert on significant line shifts for my teams</div>
          </div>
          <div
            className={`toggle ${bettingLineMoves ? '' : 'off'}`}
            onClick={() => setBettingLineMoves(!bettingLineMoves)}
          ></div>
        </div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Friend Reviews</div>
            <div className="desc">When friends post a new game review</div>
          </div>
          <div
            className={`toggle ${friendReviews ? '' : 'off'}`}
            onClick={() => setFriendReviews(!friendReviews)}
          ></div>
        </div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Foam Finger Upvotes</div>
            <div className="desc">When someone upvotes my chats or reviews</div>
          </div>
          <div
            className={`toggle ${foamFingerUpvotes ? '' : 'off'}`}
            onClick={() => setFoamFingerUpvotes(!foamFingerUpvotes)}
          ></div>
        </div>
      </div>

      <div className="settings-section">
        <div className="settings-section-title">Default Review Privacy</div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Post Reviews as Public by Default</div>
            <div className="desc">Can always change per-review</div>
          </div>
          <div
            className={`toggle ${publicReviews ? '' : 'off'}`}
            onClick={() => setPublicReviews(!publicReviews)}
          ></div>
        </div>
      </div>

      <div className="settings-section">
        <div className="settings-section-title">Account</div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Connected to Contacts</div>
            <div className="desc">Find friends from your phone contacts</div>
          </div>
          <div style={{ fontSize: '12px', color: 'var(--fd-green-light)', fontWeight: '600' }}>Enabled</div>
        </div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title">Preferred Sports</div>
            <div className="desc">NBA, NFL, MLB, NHL</div>
          </div>
          <div style={{ fontSize: '12px', color: 'var(--fd-muted)' }}>Edit ›</div>
        </div>
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="title" style={{ color: 'var(--fd-red)' }}>Delete Account</div>
          </div>
          <i className="ti ti-chevron-right" style={{ color: 'var(--fd-muted)' }} aria-hidden="true"></i>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
